<template src="./template.html"></template>

<script>
import Vue from 'vue'
import TENKENGYOUMU_BASE from 'src/consts/tenkengyoumu_base'
import TENKENGYOUMU_DETAIL from 'src/consts/tenkengyoumu_detail'
import masterMixin from 'src/mixins/masterMixin'
import notificationMixin from 'src/mixins/notificationMixin'
import tenkenDataRojouApi from 'src/apis/tenken_data_rojou'
import tenkenDataRokaApi from 'src/apis/tenken_data_roka'

const apiMap = {
  [TENKENGYOUMU_BASE.ROJOU]: tenkenDataRojouApi,
  [TENKENGYOUMU_BASE.ROKA]: tenkenDataRokaApi,
}

const csvTypeMap = {
  [TENKENGYOUMU_BASE.ROJOU]: {
    [TENKENGYOUMU_DETAIL.DOBOKU]: '路上土木',
    [TENKENGYOUMU_DETAIL.SHISETSU_DENKI]: '路上施設電気',
  },
  [TENKENGYOUMU_BASE.ROKA]: {
    [TENKENGYOUMU_DETAIL.DOBOKU]: '路下土木',
    [TENKENGYOUMU_DETAIL.SHISETSU_DENKI]: '路下施設電気',
  },
}

export default {
  name: 'hoshu-report',
  data() {
    return {
      search: {
        tantoujimushoId: '', //　computed「isAllTantoujimushosTargeted」を正しく評価するため、定義を明確にする
      },

      tenkengyoumuBaseCands: [],
      tenkengyoumuDetailCands: [],
      origTantoujimushoCands: [],
      tantoujimushoCands: [],

      isDownloading: false,
      canDownloadCSV: true,
    }
  },
  computed: {
    isAllTantoujimushosTargeted() {
      return this.search.tantoujimushoId === '-1'
    },
  },
  async mounted() {
    await this.ensureUserAndMasters()
    this.prepareMasters()
    this.prepareSearchParams()
  },
  mixins: [masterMixin, notificationMixin],
  methods: {
    prepareMasters() {
      const master = window.master
      this.tenkengyoumuBaseCands = master.tenkengyoumu_base.vals.filter(e => {
        return (parseInt(e.m_tenkengyoumu_base_id) === TENKENGYOUMU_BASE.ROJOU) ||
          (parseInt(e.m_tenkengyoumu_base_id) === TENKENGYOUMU_BASE.ROKA)
      })
      this.tenkengyoumuDetailCands = master.tenkengyoumu_detail.vals.filter(e => {
        const tenkengyoumuDetailId = parseInt(e.m_tenkengyoumu_detail_id)
        return (tenkengyoumuDetailId === TENKENGYOUMU_DETAIL.DOBOKU) ||
          (tenkengyoumuDetailId === TENKENGYOUMU_DETAIL.SHISETSU_DENKI)
      })
      this.origTantoujimushoCands = master.tantoujimusho.vals
    },
    prepareSearchParams() {
      const search = {
        tantoujimushoId: '',
      }
      const now = new Date()
      now.setHours(0, 0, 0, 0)
      search.tenkenDateFrom = now
      search.tenkenDateTo = now
      if (this.tenkengyoumuBaseCands.length > 0) {
        search.tenkengyoumuBaseId = this.tenkengyoumuBaseCands[0].m_tenkengyoumu_base_id
      }
      if (this.tenkengyoumuDetailCands.length > 0) {
        search.tenkengyoumuDetailId = this.tenkengyoumuDetailCands[0].m_tenkengyoumu_detail_id
      }
      this.search = search

      this.filterTantoujimushoCands()
    },
    filterTantoujimushoCands() {
      const dtFrom = new Date(this.search.tenkenDateFrom)
      const dtTo = new Date(this.search.tenkenDateTo)

      this.tantoujimushoCands = this.origTantoujimushoCands.filter(e => {
        return e.detail_gyoumu_id === this.search.tenkengyoumuDetailId
      }).filter(e => {
        const startDt = new Date(e.start_date)
        const endDt = new Date(new Date(e.end_date).valueOf() + 86400 * 1000)
        return (startDt <= dtFrom) && (dtTo <= endDt)
      })

      if (!this.isAllTantoujimushosTargeted) {
        const tantoujimsuho = this.tantoujimushoCands.find(
          e => e.m_tantoujimusho_id === this.search.tantoujimushoId
        ) ?? this.tantoujimushoCands[0]
        /* eslint-disable-next-line camelcase */
        this.search.tantoujimushoId = tantoujimsuho?.m_tantoujimusho_id ?? null
      }
    },
    downloadBlobAsFile(blob, filename) {
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = filename
      a.click()
    },
    async downloadCSV() {
      if (this.isDownloading) { return }

      this.isDownloading = true
      try {
        const search = this.search
        const reqObj = {
          detail_gyoumu_id: search.tenkengyoumuDetailId,
          jimusho_ids: (this.isAllTantoujimushosTargeted
            ? this.tantoujimushoCands.slice()
            : this.tantoujimushoCands.filter(e => e.m_tantoujimusho_id === search.tantoujimushoId)
          ).map(e => e.m_tantoujimusho_id),
          dt_from: search.tenkenDateFrom,
          dt_to: search.tenkenDateTo,
        }
        const tenkengyoumuBaseId = parseInt(search.tenkengyoumuBaseId)
        const tenkengyoumuDetailId = parseInt(search.tenkengyoumuDetailId)
        const { data } = await apiMap[tenkengyoumuBaseId].downloadHoshuReportCSV(reqObj)
        const timestamp = Vue.filter('dtFormat')(new Date(), 'yyyymmddHHMMSS')
        const csvType = csvTypeMap[tenkengyoumuBaseId][tenkengyoumuDetailId]
        const filename = `点検補修台帳_${csvType}_${timestamp}.csv`
        this.downloadBlobAsFile(data, filename)
        this.isDownloading = false
      } catch (err) {
        const msg = '点検補修台帳の出力に失敗しました。' +
          '管理者に連絡してください。'
        this.notifyError1(msg, { err })
        this.isDownloading = false
      }
    },
    async checkDownloadCSVAvailable() {
      const isValid = await this.$refs.search.validate()
      if (!isValid || this.isDownloading) {
        this.canDownloadCSV = false
        return
      }

      // 全事務所の場合は、最大１ヶ月までcsv出力可能
      if (this.isAllTantoujimushosTargeted) {
        const dayMilliseconds = 24 * 60 * 60 * 1000
        const searchEndTimestamp = this.search.tenkenDateTo.valueOf() + dayMilliseconds
        const searchStartTimestamp = this.search.tenkenDateFrom.valueOf()
        this.canDownloadCSV = searchEndTimestamp - searchStartTimestamp <= 31 * dayMilliseconds
        return
      }
      this.canDownloadCSV = true
    },
    onTenkenDateChanged() {
      this.filterTantoujimushoCands()
      this.checkDownloadCSVAvailable()
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
